<div
  class="list"
  [ngClass]="listClass + (card ? ' card gpx-16 gpx-sm-24' : '')"
>
  <ng-content select="app-list-item"></ng-content>
</div>
